import styled from 'styled-components'

export const DescriptionStyled = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: #000000;
`
